import { useState } from 'react'
import PropTypes from 'prop-types'

import Stepper from '../../../../../Stepper/Stepper'

const BaseView = ({ goBack, steps }) => {
  const [currentStep, setCurrentStep] = useState(0)
  const handleNext = () => {
    setCurrentStep((prev) => prev + 1)
  }
  const handleBack = () => {
    if (!currentStep) {
      return goBack()
    }
    setCurrentStep((prev) => prev - 1)
  }

  const renderStep = () => {
    const { Component, config } = steps[currentStep]
    return <Component onNext={handleNext} onBack={handleBack} {...config} />
  }

  return (
    <div>
      <Stepper currentStep={currentStep} steps={steps.map((step) => step.title)} />
      {renderStep()}
    </div>
  )
}

BaseView.propTypes = {
  goBack: PropTypes.func,
  steps: PropTypes.array,
}

export default BaseView
